import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter } from "react-router";
import { AuthProvider } from "./context/AuthContext";
import { Notifications } from "@mantine/notifications";
import { GlobalStyle, theme } from "./theme";
import { ThemeProvider } from "styled-components";
import AppRoutes from "./routes/AppRoutes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <GlobalStyle />
      <MantineProvider>
        <ThemeProvider theme={theme}>
          <Notifications />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ThemeProvider>
      </MantineProvider>
    </AuthProvider>
  </React.StrictMode>
);
